<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<orbit-aside-v2 [hasOutcomeActions]="true">
<div orbitAsideBody [formGroup]="dataForm" class="form-background ticket-shop-design-form__body">
	<div class="header-mat-card-padding">
		<mat-card class="header-width-pixels form-card">
			<mat-card-content>
				<div class="flex-layout-row flex-layout-align-space-between-center">
					<div class="flex-layout-row flex-layout-gap-20px">
						<div class="flex-layout-row flex-layout-gap-20px name-input">
							<mat-form-field class="flex-layout-align-center">
								<mat-label>Name</mat-label>
								<input formControlName="name" matInput tabIndex="1" />
								<mat-error *ngIf="name.touched && name.errors?.required"> Name is required </mat-error>
								<mat-error *ngIf="name.touched && name.errors?.maxlength"> Name must be no more than 200 characters </mat-error>
							</mat-form-field>
						</div>
						<div class="show-hide-form-button">
							<button mat-raised-button tabIndex="62" (click)="showHide()" [title]="showHideTitle()">{{ showHideTitle() }}</button>
						</div>
					</div>
				</div>
				<concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="flex-layout-row">
		<div *ngIf="showForm" class="form-width-pixels form-mat-card-padding">
			<mat-card class="main-card">
				<mat-card-content>
					<div class="flex-layout-column flex-layout-gap-20px">
						<collapsible-form-region headerText="BACKGROUND" [startTabIndex]="2" [hasError]="getBackgroundHasError()">
							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Background Colour</mat-label>
									<colour-picker formControlName="backgroundColour" [startTabIndex]="3"></colour-picker>
								</div>
							</div>
							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="useDefaultBackgroundImage" [tabIndex]="4">Use Default Background Image?</orbit-slide-toggle>
							</div>

							<div class="flex-layout-column">
								<mat-label class="display-label">Background Image</mat-label>
								<kaleida-upload
									formControlName="backgroundImage"
									[configuration]="imageUploadConfiguration"
									(fileRemoved)="setImageDeleted(true)"></kaleida-upload>
								<pseudo-form-field-error [errorMessage]="backgroundImageErrorMessage()" [showError]="getBackgroundHasError()"> </pseudo-form-field-error>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="HEADER" [startTabIndex]="7" [hasError]="getHeaderHasError()">
							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="useDefaultLogo" [tabIndex]="8">Use Default Logo Image?</orbit-slide-toggle>
							</div>

							<div class="flex-layout-column">
								<mat-label class="display-label">Header Logo</mat-label>
								<kaleida-upload
									formControlName="logo"
									[configuration]="imageUploadConfiguration"
									(fileRemoved)="setImageDeleted(false)"></kaleida-upload>
								<pseudo-form-field-error [errorMessage]="headerLogoErrorMessage()" [showError]="getHeaderLogoHasError()"> </pseudo-form-field-error>
							</div>

							<div class="flex-layout-column">
								<div class="flex-layout-row flex-layout-align-space-between-center">
									<orbit-slide-toggle size="small" formControlName="showSocialMediaLinks" [tabIndex]="11" [disabled]="socialMedialListInvalid">Show Social Media Links?</orbit-slide-toggle>
								</div>
								<pseudo-form-field-error [errorMessage]="'There are validation errors on the Social Media link URLs - please correct'" [showError]="socialMedialListInvalid"> </pseudo-form-field-error>
							</div>
							<div *ngIf="showSocialMediaList">
								<social-media-form-list [parentFormGroup]="dataForm" [formArray]="socialMediaArray" [startTabIndex]="12"></social-media-form-list>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Heading Background Colour</mat-label>
									<colour-picker formControlName="headingBackgroundColour" [startTabIndex]="24"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Heading Text Colour</mat-label>
									<colour-picker formControlName="headingTextColour" [startTabIndex]="25"></colour-picker>
								</div>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="GENERAL" [startTabIndex]="26">
							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Border Colour</mat-label>
									<colour-picker formControlName="borderColour" [startTabIndex]="27"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Content Area Background Colour</mat-label>
									<colour-picker formControlName="contentAreaBackgroundColour" [startTabIndex]="28"></colour-picker>
								</div>
							</div>

							<div>
								<mat-form-field>
									<mat-label>Rounded Corners</mat-label>
									<mat-select formControlName="roundedCorners" name="roundedCorners" tabIndex="29">
										<mat-option *ngFor="let lookup of roundedCornersLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="controlShadow" [tabIndex]="30">Control Shadow (button, content area, header etc.)</orbit-slide-toggle>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="FONTS AND TEXT" [startTabIndex]="31">
							<div>
								<mat-form-field>
									<mat-label>Base Font Size</mat-label>
									<mat-select formControlName="baseFontSize" name="baseFontSize" tabIndex="32">
										<mat-option *ngFor="let lookup of baseFontSizeLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div>
								<mat-form-field>
									<mat-label>Heading Font</mat-label>
									<mat-select formControlName="headingFont" name="headingFont" tabIndex="33">
										<mat-option *ngFor="let lookup of headingFontLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="headingFontUppercase" [tabIndex]="34">Heading Font Uppercase?</orbit-slide-toggle>
							</div>

							<div>
								<mat-form-field>
									<mat-label>Standard Text Font</mat-label>
									<mat-select formControlName="standardTextFont" name="standardTextFont" tabIndex="35">
										<mat-option *ngFor="let lookup of standardTextFontLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Standard Text Font Colour</mat-label>
									<colour-picker formControlName="standardTextFontColour" [startTabIndex]="36"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Important Text Font Colour</mat-label>
									<colour-picker formControlName="importantTextFontColour" [startTabIndex]="37"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Link Colour</mat-label>
									<colour-picker formControlName="linkColour" [startTabIndex]="38"></colour-picker>
								</div>
							</div>

							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="linkUnderline" [tabIndex]="39">Link Underline?</orbit-slide-toggle>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Hover Colour</mat-label>
									<colour-picker formControlName="hoverColour" [startTabIndex]="40"></colour-picker>
								</div>
							</div>

							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="hoverUnderline" [tabIndex]="41">Hover Underline?</orbit-slide-toggle>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="BUTTONS" [startTabIndex]="42">
							<div>
								<mat-form-field>
									<mat-label>Button Font</mat-label>
									<mat-select formControlName="buttonFont" name="buttonFont" tabIndex="43">
										<mat-option *ngFor="let lookup of buttonFontLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="buttonFontUppercase" [tabIndex]="44">Button Font Uppercase?</orbit-slide-toggle>
							</div>

							<div>
								<mat-form-field>
									<mat-label>Button Rounded Corners</mat-label>
									<mat-select formControlName="buttonRoundedCorners" name="buttonRoundedCorners" tabIndex="45">
										<mat-option *ngFor="let lookup of buttonRoundedCornersLookupData" [value]="lookup.id">
											{{ lookup.text }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Primary Button Background Colour</mat-label>
									<colour-picker formControlName="primaryButtonBackgroundColour" [startTabIndex]="46"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Primary Button Text Colour</mat-label>
									<colour-picker formControlName="primaryButtonTextColour" [startTabIndex]="47"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Primary Button Border Colour</mat-label>
									<colour-picker formControlName="primaryButtonBorderColour" [startTabIndex]="48"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Secondary Button Background Colour</mat-label>
									<colour-picker formControlName="secondaryButtonBackgroundColour" [startTabIndex]="49"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Secondary Button Text Colour</mat-label>
									<colour-picker formControlName="secondaryButtonTextColour" [startTabIndex]="50"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
									<mat-label class="no-formfield">Secondary Button Border Colour</mat-label>
									<colour-picker formControlName="secondaryButtonBorderColour" [startTabIndex]="51"></colour-picker>
								</div>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="HOME PAGE" [startTabIndex]="52" [hasError]="getHomePageHasError()">
							<div>
								<ticket-shop-layout-picker [startTabIndex]="52" formControlName="homepageLayout" [layoutStyleLookupData]="homepageLayoutLookupData"></ticket-shop-layout-picker>
								<pseudo-form-field-error [errorMessage]="'Home Page Layout Selection is required'" [showError]="homepageLayout.touched && homepageLayout.errors?.required"> </pseudo-form-field-error>
							</div>
							<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center">
								<orbit-slide-toggle size="small" formControlName="enableSearch" [tabIndex]="58">Enable Search?</orbit-slide-toggle>
							</div>
						</collapsible-form-region>

						<collapsible-form-region headerText="FOOTER" [startTabIndex]="59" [hasError]="getFooterHasError()">
							<div>
								<mat-form-field>
									<mat-label>Terms and Conditions URL</mat-label>
									<input formControlName="termsAndConditionsUrl" matInput tabIndex="60" />
									<mat-error *ngIf="termsAndConditionsUrl.touched && termsAndConditionsUrl.errors?.required"> Terms and Conditions URL is required </mat-error>
									<mat-error *ngIf="termsAndConditionsUrl.touched && termsAndConditionsUrl.errors?.maxlength && !termsAndConditionsUrl.errors?.pattern"> Terms and Conditions URL must be no more than 200 characters </mat-error>
									<mat-error *ngIf="termsAndConditionsUrl.touched && termsAndConditionsUrl.errors?.pattern"> Terms and Conditions URL must be a correctly formatted website URL </mat-error>
								</mat-form-field>
							</div>

							<div>
								<mat-form-field>
									<mat-label>Contact Us URL</mat-label>
									<input formControlName="contactUsUrl" matInput tabIndex="61" />
									<mat-error *ngIf="contactUsUrl.touched && contactUsUrl.errors?.required"> Contact Us URL is required </mat-error>
									<mat-error *ngIf="contactUsUrl.touched && contactUsUrl.errors?.pattern"> Contact Us URL must be a correctly formatted website URL </mat-error>
									<mat-error *ngIf="contactUsUrl.touched && contactUsUrl.errors?.maxlength && !contactUsUrl.errors?.pattern"> Contact Us URL must be no more than 200 characters </mat-error>
								</mat-form-field>
							</div>
						</collapsible-form-region>
					</div>
				</mat-card-content>
			</mat-card>
		</div>

		<div class="preview-width-pixels" [ngClass]="{ 'preview-width-pixels': showForm, 'full-width-preview': !showForm }">
			<mat-card class="main-card">
				<mat-card-content>
					<ticket-shop-design-preview-view [ticketShopDesignId]="data.itemId" [eventId]="data.eventId"></ticket-shop-design-preview-view>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
	<div orbitAsideFooter class="aside-content ticket-shop-design-form__footer flex-layout-row flex-layout-gap-10px">
		<button mat-raised-button (click)="save(true)" color="primary" tabIndex="63">Publish Event Preview</button>
		<button mat-raised-button (click)="save(false)" color="primary" tabIndex="64">{{ saveText }}</button>
		<button mat-raised-button (click)="cancel()" tabIndex="65">Cancel</button>
	</div>
</orbit-aside-v2>
